import { Button } from '@components/atoms/Button';
import { Card } from '@components/atoms/Card';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import React from 'react';
import { Crew } from '@models/crew.model';

interface CrewHeaderProps {
  crew: Crew;
  onEdit: () => void;
  onDelete: () => void;
}

export const CrewHeader: React.FC<CrewHeaderProps> = ({
  crew,
  onEdit,
  onDelete,
}) => {
  return (
    <div className="flex flex-col">
      <Card>
        <div className="flex gap-4 flex-col md:flex-row md:items-start md:justify-between md:gap-6">
          <div className="flex items-start flex-col gap-2">
            <div className="text-2xl font-bold capitalize text-gray-900 dark:text-gray-100">
              {crew?.name}
            </div>
          </div>
          <div className="flex gap-2 md:self-start">
            <Button
              onClick={onEdit}
              variant="tertiary"
              leftIcon={<ModeEditOutlinedIcon sx={{ fontSize: '16px' }} />}>
              Edit
            </Button>
            <Button variant="tertiary" onlyIcon onClick={onDelete}>
              <DeleteOutlineOutlinedIcon sx={{ fontSize: '16px' }} />
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};
